var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-12 col-md-2 mb-4"
  }, [_c('ul', {
    staticClass: "nav nav-pills flex-column"
  }, _vm._l(_vm.serviceTypesFiltered, function (tab, index) {
    return _c('li', {
      key: index,
      staticClass: "nav-item"
    }, [_c('router-link', {
      staticClass: "nav-link",
      class: {
        active: tab.identifier === _vm.serviceTypeIdentifier
      },
      attrs: {
        "tag": "a",
        "to": {
          name: 'locationEditServiceTimes',
          params: {
            serviceTypeIdentifier: tab.identifier
          }
        }
      }
    }, [_vm._v(" " + _vm._s(tab.display_name) + " ")])], 1);
  }), 0)]), _vm.serviceTypeIdentifier ? _c('div', {
    staticClass: "col-12 col-md-10"
  }, [_vm.serviceTypeUnavailable ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(" U heeft onvoldoende rechten om de service tijden van type '" + _vm._s(_vm.serviceTypeIdentifier) + "' te bekijken. ")]) : _c('edit-service-times-for-type', {
    key: _vm.serviceTypeIdentifier,
    attrs: {
      "location": _vm.location,
      "service-type": _vm.selectedServiceType,
      "use-cut-off": !!_vm.selectedServiceType.is_cutoff
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }